import React from 'react'
import Header from '../components/Header'
import SiteFooter from '../components/SiteFooter'

export default function DefaultLayout ({ children }) {
  return (
    <React.Fragment>
      <Header />
      {children}
      <SiteFooter />
    </React.Fragment>
  )
}
